import { realApi } from './api';

// Nada derivado se guarda, así que esto son vistas de solo
// lectura (v_ranking_participantes/v_ranking_jugadores/v_ranking_clubes), no
// una colección editable. Sin filtro de modalidad devuelve todas mezcladas;
// Ranking.js las agrupa por el campo `modalidad` de cada fila.
export const getRankingParticipantesReal = (temporadaId) =>
  realApi.get(`/temporadas/${encodeURIComponent(temporadaId)}/ranking?porPagina=200`).then((r) => r.datos);

export const getRankingJugadoresReal = (temporadaId) =>
  realApi.get(`/temporadas/${encodeURIComponent(temporadaId)}/ranking-jugadores?porPagina=200`).then((r) => r.datos);

export const getRankingClubesReal = (temporadaId) =>
  realApi.get(`/temporadas/${encodeURIComponent(temporadaId)}/ranking-clubes?porPagina=200`).then((r) => r.datos);
